<template>
<div v-if="isVisible">

<!-- :class="return_style_stud_current(true)"  -->

<div class="columns is-mobile is-gapless is-vcentered" style="margin-bottom:0em;">
<!-- <div class="column is-2">          
<figure class="image is-32x32">
    <img :src="return_pic(data.student_PhotoPath)" onerror="javascript:this.src='https://space-zytco.nyc3.digitaloceanspaces.com/photos/noImage.png'" alt="....">
</figure>       
</div> -->
<div class="column is-10">         
    <div class="columns is-multiline is-gapless">      
        <div class="column is-12 has-text-weight-bold" style="">{{data.student_lNAME}}</div>
        <div class="column is-8 is-size-7" style="margin-top:-.5em;"> {{data.student_fNAME}}</div>
        <div class="column is-4 is-size-7 has-text-info has-text-right has-text-weight-bold" style="margin-top:-.5em;">{{data.student_GRPCODE}}&nbsp;&nbsp;</div>
    </div>
</div>
  
    <div class="column is-2">
        
<button v-if="operation=='REMOVE' && !isDirty" style="margin-top:-.5em;" class="button is-fullwidth has-background-white has-text-danger" @click="click_remove(data.student_ID)"><span class="icon is-small"><i class="fas fa-user-times"></i></span></button>
<button v-else-if="operation=='ADD' && !isDirty" style="margin-top:-.5em;" class="button is-fullwidth has-background-white has-text-success" @click="click_add(data.student_ID)"><span class="icon is-small"><i class="fas fa-user-plus"></i></span></button>
<button v-else style="margin-top:-.5em;" class="button is-fullwidth has-background-white has-text-dark" @click="click_undo(data.student_ID)"><span class="icon is-small"><i class="fas fa-undo"></i></span></button>

    </div>

</div>

 



</div>
</template>

<script>
//import axios from 'axios';

export default {
        props: [ 'data', 'btnType' , 'selected' ],
        components: {  },

        data() {
            return {
                operation:'',
                isDirty:false,
                isEnabled:false,
                isVisible:true,
            }
        },

mounted() {
    this.operation= this.btnType
    //this.isEnabled= this.enabled

    //this.isDirty = this.selected
},



methods : {

click_remove:function(studentID) { 
    this.isDirty = true;
    this.$emit('emit_click_remove', studentID)
},
click_add:function(studentID) {
    
    // alert('yo')
    this.isDirty = true;
    setTimeout(() => { this.$emit('emit_click_add', studentID) }, 100);
   // 
    
    // this.isVisible = false
},

click_undo:function(studentID) { 
    this.isDirty = false;
    if (this.btnType == "REMOVE")
    { this.$emit('emit_click_remove_undo', studentID) }
    else { this.$emit('emit_click_add_undo', studentID) }
},




return_pic:function(pic) {
    return 'https://space-zytco.nyc3.digitaloceanspaces.com/photos/'+pic
},

}, // END METHODS


}
</script>